<template>
  <div></div>
</template>

<script>
import { startRouteMixin } from "@/mixins/startRouteMixin";
import { AuthService } from "@/services/auth.service";
import AuthUtil from "@/utils/auth.util";

export default {
  mixins: [startRouteMixin],
  mounted() {
    const fn = async () => {
      // Logout user from auth0 when user is logged out from laravel
      // User won't be redirected to auth0 login page if user is logged out from laravel but not from auth0
      // Moving this auth0 logout to the parts where laravel logout happens (e.g. axios interceptors, header logout)
      // Conveniently, we can move this to store.auth.clearToken()
      // if (!this.$store.state.Auth.token) {
      //   this.$auth.logout({
      //     returnTo: `${window.location.origin}/login`,
      //   });
      // }

      if (!this.$auth.isAuthenticated) {
        this.$auth.loginWithRedirect();
      } else {
        this.$store.dispatch("routeLoading", true);

        const token = await this.$auth.getTokenSilently();
        AuthUtil.setAuth0Token(token);

        try {
          const response = await AuthService.loginAuth0({ token });
          this.$store.dispatch("Auth/setToken", response.body.token);
          // this.$router.push({ name: "profile" });
          this.navigateToStartRoute();
        } catch (err) {
          this.$auth.logout({
            returnTo: `${window.location.origin}/errors/contact-healthy-waters`,
          });
        }

        this.$store.dispatch("routeLoading", false);
      }
    };

    // If loading has already finished, check our auth state using `fn()`
    if (!this.$auth.loading) {
      return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    this.$auth.$watch("loading", (loading) => {
      if (loading === false) {
        return fn();
      }
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Login/auth0.vue